import InviteFriendsDialog from "./InviteFriendsDialog";
import ShareProductDialog from "./ShareProductDialog";
import ConnectRetailerDialog from "./ConnectRetailerDialog";
import SurveyLimitDialog from "./SurveyLimitDialog";
import DisconnectRetailerDialog from "./DisconnectRetailerDialog";
import GenericDialog from "./GenericDialog";
import GenericDialogNoClose from "./GenericDialogNoClose";
import LoadingOverlay from "./LoadingOverlay";
const AppDialogs = () => {
  return (
    <>
      {/* Dialogs */}
      <InviteFriendsDialog />
      <ShareProductDialog />
      <ConnectRetailerDialog />
      <DisconnectRetailerDialog />
      <GenericDialog />
      <GenericDialogNoClose />
      <SurveyLimitDialog />

      {/* Overlays */}
      <LoadingOverlay />
    </>
  );
};

export default AppDialogs;
